import React from 'react'
import { graphql } from 'gatsby'
import { PageHelmet } from '../../../common/components'
import AptitudeTest from '../components/AptitudeTest'
import BannerAptitudeTest from '../components/BannerAptitudeTest'
import JobSeekersGuide from '../components/JobSeekersGuide'
import JobTest from '../components/JobTest'
import JobTestSticky from '../components/JobTestSticky'
import PracticeTest from '../components/PracticeTest'
import ScoresMarking from '../components/ScoresMarking'
import TakingTest from '../components/TakingTest'
import TipsForSuccess from '../components/TipsForSuccess'

const PracticeAptitudeTest = ({ data: { allDatoCmsToken = {} } }) => {
  const tokens = allDatoCmsToken.edges
  return (
    <div id="practice-aptitude-page" className="d-flex flex-column">
      <PageHelmet
        title="Aptitude Test: 16 Free Tests with 129+ Questions and Answers"
        description="Gain access to the best free aptitude tests online. Practice more than 100 questions with answers for 16 aptitude assessments with expert tips."
        url={process.env.GATSBY_SITE_BASE_URL}
        image={`${process.env.GATSBY_SITE_BASE_URL}/prt.png`}
      />
      <JobTestSticky
        tokens={tokens}
        buyLink="https://www.jobtestprep.co.uk/shl-practice-tests#PRT"
        freeLink="https://www.jobtestprep.co.uk/shl-practice-tests#PRT"
        // buyLink="https://tests.practicereasoningtests.com/aptitude-test?tid1=practice-aptitude-tests&tid2=stickyheadertests&tid3=articles&tid4=PRT"
        // freeLink="https://tests.practicereasoningtests.com/aptitude-test?tid1=practice-aptitude-tests&tid2=stickyfreebutton&tid3=articles&tid4=PRT"
      />
      <BannerAptitudeTest />

      <AptitudeTest />
      <JobSeekersGuide />
      <ScoresMarking />
      <TakingTest />
      <TipsForSuccess />
      <JobTest
        // link={'https://tests.practicereasoningtests.com/practice'}
        image="jobtestprepmobile.jpeg"
        link="https://www.jobtestprep.co.uk/shl-practice-tests#PRT"
      />
    </div>
  )
}

export const query = graphql`
  {
    allDatoCmsToken {
      edges {
        node {
          key
          value
          valueMarkdown {
            markdownNode {
              childMarkdownRemark {
                html
              }
            }
          }
        }
      }
    }
  }
`

export default PracticeAptitudeTest
